import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import './_styles_/SettingsRow.css';
import { onActionKey } from '../../utils';
import useDetailHandler from '../../hooks/useDetailHandler';

SettingsRow.propTypes = {
    name: PropTypes.string.isRequired,
    detailPath: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    description: PropTypes.string,
};

SettingsRow.defaultProps = {
    description: '',
};

function SettingsRow(props) {
    const {
        name,
        detailPath,
        description,
        children,
    } = props;
    const { isDetailVisible, toggleDetail } = useDetailHandler(detailPath);
    return (
        <>
            <div className="rich-list-row settings-row-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="settings-row-header--values--name">{name}</div>
                <div className="settings-row-header--values--description">{description}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && children}
        </>
    );
}

export default SettingsRow;
